<ng-container *ngIf="templateOptions.style === 'button'">
  <mat-button-toggle-group
    name="dateSelection"
    #toggleGroup="matButtonToggleGroup"
    (change)="onDateSelectionChange($event)"
    class="dateRangeButtonGroup"
  >
    <mat-button-toggle
      *ngFor="let range of ranges"
      [value]="range"
      [checked]="range.label === templateOptions.defaultRange"
      class="buttonToggle"
      >{{ range.label }}</mat-button-toggle
    >
    <mat-button-toggle
      [matMenuTriggerFor]="timeRangeMenu"
      [value]="'none'"
      *ngIf="this.templateOptions.custom"
      class="finalButtonToggle"
      >{{ '•••' }}</mat-button-toggle
    >
    <mat-menu #timeRangeMenu="matMenu">
      <ng-container *ngFor="let extendedRange of templateOptions.extendedRanges">
        <button mat-menu-item (click)="onChangeTimeRangeMenu(extendedRange)">
          {{ extendedRange.label }}
        </button>
      </ng-container>
      <button mat-menu-item (click)="onDateSelectionChange({value: 'custom'})">{{ 'common.customRange' | t }}</button>
    </mat-menu>
  </mat-button-toggle-group>
</ng-container>

<ng-container *ngIf="templateOptions.style === 'dropdown'">
  <mat-select
    [(value)]="dateSelection"
    [placeholder]="modelSearchRangeMessage"
    (click)="onDateSelectionChange({value: 'custom'})"
    [matTooltip]="modelSearchRangeMessage"
  >
  </mat-select>
</ng-container>
